import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_CLIENT_CONFIG } from '../core/api-client-config';
import { FeatureCollection } from '../models';

@Injectable({ providedIn: 'root' })
export class MapboxApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly accessToken = inject(API_CLIENT_CONFIG).mapboxAccessToken;
  private readonly baseUrl = 'https://api.mapbox.com/search/geocode/v6';

  searchLocations({ city }: { city: string }): Observable<FeatureCollection> {
    return this.httpClient.get<FeatureCollection>(`${this.baseUrl}/forward`, {
      params: {
        access_token: this.accessToken ?? '',
        q: city,
        country: 'it',
        limit: 1,
      },
    });
  }
}
